import React from "react";
import Navigation from "../components/Navigation/Navigation";

export default function Header() {
  return (
    <header id="techtomed-header-wrapper">
      <Navigation />
    </header>
  );
}
